<template>
  <div class="ball-display__balls">
    <div v-for="(n, i) in mainNumbers" :key="'m-' + i" class="ball-col">
      <div class="ball" :class="ballColorClass(i)">
        <span class="ball-num">{{ slotIsDrawing(i) ? drawingChars[i] : n.value }}</span>
        <span v-if="!drawPhaseNear && !slotIsDrawing(i)" class="ball-zodiac">{{ n.zodiac }}</span>
      </div>
    </div>
    <div class="ball-col ball-col--plus"><span>+</span></div>
    <div class="ball-col">
      <div class="ball" :class="ballColorClass(6)">
        <span class="ball-num">{{ slotIsDrawing(6) ? drawingChars[6] : special.value }}</span>
        <span v-if="!drawPhaseNear && !slotIsDrawing(6)" class="ball-zodiac">{{ special.zodiac }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BallDisplay',
  props: {
    mainNumbers: { type: Array, required: true },
    special: { type: Object, required: true },
    drawPhaseNear: { type: Boolean, default: false },
    pollSlotRevealed: { type: Array, default: null },
    drawRevealed: { type: Array, default: null },
    isLiveDrawing: { type: Boolean, default: false },
    drawingChars: { type: Array, default: () => ['正','在','进','行','开','奖','中'] },
    ballTone: { type: Function, required: true }
  },
  methods: {
    slotIsDrawing(index) {
      if (this.drawPhaseNear) return true
      if (this.pollSlotRevealed != null && this.pollSlotRevealed[index] !== true) return true
      if (this.drawRevealed != null && this.drawRevealed[index] !== true) return true
      const ball = index < 6 ? this.mainNumbers[index] : this.special
      if (!ball || !ball.value) return true
      return false
    },
    ballColorClass(index) {
      if (this.slotIsDrawing(index)) return 'ball--drawing'
      const ball = index < 6 ? this.mainNumbers[index] : this.special
      return 'ball--' + this.ballTone(ball)
    }
  }
}
</script>

<style scoped>
.ball-display__balls {
  display: flex; align-items: flex-start; gap: clamp(0.15rem, 1vw, 0.35rem);
  flex: 1; min-width: 0; width: 100%;
}
.ball-col {
  flex: 1 1 0; min-width: 0;
}
.ball-col--plus {
  flex: 0 0 auto; width: clamp(0.5rem, 2.5vw, 0.75rem);
  align-self: center; display: flex; justify-content: center;
  font-size: clamp(1rem, 4.5vw, 1.4rem); font-weight: 800; color: #999;
}
.ball {
  width: 100%; height: clamp(3rem, 14vw, 4rem);
  border-radius: 4px;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
}
.ball--red   { background: #e71607; }
.ball--blue  { background: #2389e9; }
.ball--green { background: #1fb61d; }
.ball--drawing { background: #bdbdbd; }
.ball-num {
  color: #fff; font-size: clamp(1.4rem, 7vw, 2rem);
  font-weight: 900; line-height: 1.2;
}
.ball-zodiac {
  display: inline-block; margin: 0 0 clamp(0.3rem, 1.2vw, 0.45rem);
  padding: 0 clamp(0.35rem, 2vw, 0.55rem); height: clamp(0.95rem, 4.5vw, 1.2rem);
  line-height: clamp(0.95rem, 4.5vw, 1.2rem);
  border-radius: 2px; color: #333; font-size: clamp(0.8rem, 3.2vw, 0.95rem); font-weight: 700;
  background: #fff;
  min-width: clamp(1.5rem, 7vw, 2rem);
  text-align: center;
}
</style>
